(() => {
  if (window.vicsMegaNavigation) return;
  const initialise = () => {
    document.querySelectorAll('[data-vics-navigation]').forEach((root) => {
      if (root.dataset.vicsReady === 'true') return;
      root.dataset.vicsReady = 'true';
      const items = [...root.querySelectorAll('.vics-navigation__details')];
      const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
      let heightFrame = 0;
      let previousHeight;
      const hasOpenMenu = () => items.some(item => item.open);
      const updateHeight = () => {
        heightFrame = 0;
        if (!root.isConnected || !hasOpenMenu()) return;
        const available = Math.max(180, innerHeight - root.getBoundingClientRect().bottom);
        if (available !== previousHeight) {
          root.style.setProperty('--vics-menu-available', `${available}px`);
          previousHeight = available;
        }
      };
      const scheduleHeight = () => {
        if (!heightFrame && hasOpenMenu()) heightFrame = requestAnimationFrame(updateHeight);
      };
      const setExpanded = (summary, expanded) => {
        const value = String(expanded);
        if (summary?.getAttribute('aria-expanded') !== value) summary?.setAttribute('aria-expanded', value);
      };
      const close = (item) => {
        if (item.open) item.open = false;
        setExpanded(item.querySelector('summary'), false);
      };
      items.forEach((item) => {
        const summary = item.querySelector('summary');
        setExpanded(summary, item.open);
        let closeTimer;
        item.addEventListener('pointerenter', () => {
          if (!finePointer.matches) return;
          clearTimeout(closeTimer);
          items.forEach((other) => { if (other !== item) close(other); });
          item.open = true;
        });
        item.addEventListener('pointerleave', () => {
          if (finePointer.matches) closeTimer = setTimeout(() => close(item), 160);
        });
        item.addEventListener('toggle', () => {
          setExpanded(summary, item.open);
          if (!item.open) return;
          updateHeight();
          items.forEach((other) => { if (other !== item) close(other); });
        });
        item.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          close(item);
          summary.focus();
        });
        item.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !item.contains(event.relatedTarget)) close(item);
        });
      });
      document.addEventListener('click', (event) => {
        if (!root.isConnected || root.contains(event.target)) return;
        items.forEach(close);
      });
      // A pointer-opened menu may not own keyboard focus yet.
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !root.isConnected) return;
        const opened = items.find((item) => item.open);
        if (!opened) return;
        event.preventDefault();
        items.forEach(close);
        opened.querySelector('summary')?.focus();
      });
      addEventListener('resize', scheduleHeight, { passive: true });
      document.querySelector('.page-wrapper')?.addEventListener('scroll', scheduleHeight, { passive: true });
      // Theme-editor menu choices are reflected in the mobile drawer as well.
      document.querySelectorAll('[data-vics-mobile-group-links]').forEach((target) => {
        const source = root.querySelector(`[data-vics-navigation-group="${target.dataset.vicsMobileGroupLinks}"]`);
        if (source) target.replaceChildren(...[...source.querySelectorAll('a')].map((link) => link.cloneNode(true)));
      });
    });
  };
  window.vicsMegaNavigation = { initialise };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
